<script lang="ts" setup>
import { StoryBook } from "@/types/entity";
import { useRouter } from "vue-router";
import { computed, onBeforeMount, ref } from "vue";
import { useStoryBook } from "@/stores/story-book";
import StoryBookListItem from "@/components/mobile/story/story-book/StoryBookListItem1.vue";
import { storeToRefs } from "pinia";
import { Tab, Tabs } from "vant";
import { onCurrentMateChange } from "@/stores/internal-subscribe";

const props = withDefaults(
  defineProps<{
    mateId?: number;
    hideTab?: boolean;
    fullList?: boolean;
  }>(),
  { fullList: false }
);

const router = useRouter();
const store = useStoryBook();
const { allStoryBookList } = storeToRefs(store);
// const storyBookList = ref<StoryBook[]>([]);
const loading = ref(false);
const renderBookList = computed(() => {
  if (props.mateId) {
    return allStoryBookList.value;
  } else {
    if (store.storyType === 0) {
      return allStoryBookList.value.filter((item) => !item.dtPublish);
    } else {
      return allStoryBookList.value.filter((item) => item.dtPublish);
    }
  }
});
// Lifecycle
const prepareData = async () => {
  loading.value = true;
  try {
    // if (props.mateId) {
    //   storyBookList.value = await store.fetchStoryBookList({
    //     mateId: props.mateId,
    //     published: props.fullList ? undefined : 1,
    //   });
    // } else {
    await store.getStoryBookList(true);
    // }
  } finally {
    loading.value = false;
  }
};
onCurrentMateChange(prepareData);
onBeforeMount(prepareData);
</script>
<template>
  <div class="w-full h-full flex flex-col">
    <Tabs
      v-if="!hideTab"
      v-model:active="store.storyType"
      @change="store.changeStoryBookType"
    >
      <Tab :title="$t('story.draft')"></Tab>
      <Tab :title="$t('story.published')"></Tab>
    </Tabs>
    <div v-show="loading" class="h-40 flex items-center justify-center">
      <span class="loading"></span>
    </div>
    <div
      v-show="!loading && renderBookList.length === 0"
      class="h-40 flex flex-col items-center justify-center"
    >
      <div class="text-2xl font-bold text-base-content/50">
        {{ $t("Message.noStoriesYet") }}
      </div>
      <div class="text-base-content/50">
        {{ $t("Message.noStoriesYetDesc") }}
      </div>
    </div>
    <template v-if="!loading && renderBookList.length > 0">
      <div class="p-4 grid grid-cols-2 gap-3 overflow-y-auto">
        <story-book-list-item
          v-for="item in renderBookList"
          :key="item.id"
          :story-book="item"
          :show-draft="store.storyType === 0"
          @click="
            router.push({ name: 'storyBookHome', params: { uuid: item.uuid } })
          "
        />
      </div>
    </template>
  </div>
</template>
